exports.install = function (Vue, options) {
  Vue.prototype.$config = {
    init () {
      console.log('项目运行成功！')
    },
    iswx(){
      var ua = window.navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) == 'micromessenger'){
        return true;
      }else{
        return false;
      }
    },
    wxshare (wxconfig){
      var config = wxconfig,
        title = "",
        summary = "",
        link = "",
        thumb = '',
        content = {
          title: title,
          desc:summary,
          link: link,
          imgUrl:thumb,
          type: '',
          dataUrl: '',
          success: function () {},
          cancel: function () {}
        }

      wx.config({
        debug: false,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: [
          'onMenuShareAppMessage','onMenuShareTimeline','onMenuShareQQ','onMenuShareWeibo'
        ]
      });
      wx.checkJsApi({
        jsApiList: ['onMenuShareAppMessage','onMenuShareTimeline','onMenuShareQQ','onMenuShareWeibo'],
        success: function(res) {}
      });
      wx.ready(function () {
        wx.onMenuShareAppMessage(content);
        wx.onMenuShareTimeline(content);
        wx.onMenuShareQQ(content);
        wx.onMenuShareWeibo(content);
      });
    },
  };

  // 过滤器
  Vue.filter('date',function (value) {
      var year = value.getFullYear(),
          month = value.getMonth()+1,
          day = value.getDate(),
          hour = value.getHours(),
          minute = value.getMinutes();
      return year+'年'+month+'月'+day+'日'+' '+hour+':'+minute
  })
}



// WEBPACK FOOTER //
// ./src/assets/global.js